{
    "type": {
        "daily_sales": "Daily sales",
        "discounts_report": "Discount",
        "events_report": "Events",
        "general_subscriptions": "General of subscriptions",
        "sales_commissions": "Sales commissions",
        "session_closure": "Session closure",
        "session_expired": "Expired session",
        "settlements": "Settlements",
        "sold_subscriptions": "Sold subscriptions",
        "valuation_history": "Valorations"
    }
}
